export const AreaSettingsConfig = {
  events: {
    name: 'area-settings',
    // refresh-index-data
    refresh: `rid-area-settings`,
    // slideover-right
    sorId: 'area-settings',
    sorOpen: 'sor-open-area-settings',
    sorClose: 'sor-close-area-settings',
    sorToggle: 'sor-toggle-area-settings',
    // editing-data
    editingData: 'edit-area-settings-data',
    // viewing-data
    viewingData: 'view-area-settings-data',
  },
}
